import {
  inputBaseStyles,
  inputElementStyles,
  optionStyles,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  inputBaseStyles,
  optionStyles,
  css`
    :host {
      align-items: normal;
      display: flex;
      flex-direction: column;
      row-gap: ${spacing(50)};
    }

    .input-wrapper {
      display: inline-block;
      inline-size: 100%;
      position: relative;
    }

    :where(label) {
      font-weight: bold;
    }

    :where(textarea) {
      ${inputElementStyles};
      align-items: center;
      appearance: none;
      background-color: ${token('input-background-default')};
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      flex-shrink: 0;
      inline-size: 100%;
      justify-content: center;
      margin: 0;
      resize: none;
      transition:
        background var(--tm-transition-duration-normal)
          var(--tm-transition-function-ease-out),
        border var(--tm-transition-duration-normal)
          var(--tm-transition-function-ease-out),
        color var(--tm-transition-duration-normal)
          var(--tm-transition-function-ease-out);
    }

    :where(textarea):not([disabled]):focus,
    :where(textarea):not([disabled]):focus-visible {
      border-color: ${token('albert-text-input-border-focus')};
    }

    :where(textarea):not([disabled]):hover {
      border-color: ${token('input-border-hover')};
    }

    :host([resizable]) :where(textarea) {
      resize: both;
    }

    :where(slot[name='error']) {
      color: ${token('input-helper-error')};
    }
  `,
];
